// extracted by mini-css-extract-plugin
module.exports = {"color1":"#001e3c","color2":"#f05a23"};